<template>
    <v-menu v-model="pickerOpen" :close-on-content-click="false">
        <template v-slot:activator="{on}">
            <v-btn :color="color" v-on="on">{{ activatorLabel }}</v-btn>
        </template>

        <template>
            <v-date-picker v-if="activePicker === 'date'"
                           v-model="date"
                           :allowed-dates="allowedDates"/>
            <v-time-picker v-if="activePicker === 'time'"
                           format="24hr"
                           v-model="time"
                           @click:minute="submit"
                           :allowed-hours="allowedHours"
                           :allowed-minutes="allowedMinutes"/>

        </template>

    </v-menu>
</template>

<script>
import moment from "moment";

export default {
    name: "DateTimePicker",
    props: {
        color: {},
        futureOnly: {
            type: Boolean,
            default: false
        },
        dateTime: {
            default: () => moment().add(5, 'minute')
        }
    },
    data() {
        return {
            isPickerOpen: false,
            activePicker: 'date',
//            dateTime: moment(),
            activatorLabel: "Zeitpunkt wählen",
        }
    },
    computed: {
        pickerOpen: {
            get() {
                return this.isPickerOpen;
            },
            set(value) {
                this.activePicker = 'date';
                this.isPickerOpen = value;
            }
        },
        date: {
            get() {
                return this.dateTime.format('YYYY-MM-DD')
            },
            set(value) {
                this.activePicker = 'time';
                let date = moment(value);
                this.dateTime.set({
                    year: date.get('year'),
                    month: date.get('month'),
                    date: date.get('date')
                });
            }
        },
        time: {
            get() {
                return this.dateTime.format('hh:mm')
            },
            set(value) {
                let time = value.split(':');

                this.dateTime.set({
                    hour: time[0],
                    minute: time[1],
                    second: 0
                });
            }
        },
    },
    methods: {
        allowedDates(date) {
            if (this.futureOnly) {
                return moment(date).isSameOrAfter(moment(), 'day');
            }
            return true;
        },
        allowedHours(hour) {
            if (this.futureOnly && this.dateTime.isSame(moment(), 'day')) {
                return hour >= moment().hour();
            }
            return true;
        },
        allowedMinutes(minute) {
            if (this.futureOnly && this.dateTime.isSame(moment(), 'hour')) {
                return minute >= moment().minute();
            }
            return true;
        },
        submit() {
            this.$emit('change', this.dateTime)
            this.activatorLabel = this.dateTime.format("DD.MM.YYYY HH:mm")
            this.pickerOpen = false;
        },
    }
}
</script>

<style scoped>

</style>
